import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UTILITIES_FEATURE_KEY, UtilitiesState } from './utilities.reducer';

// Lookup the 'Utilities' feature state managed by NgRx
export const selectUtilitiesState = createFeatureSelector<UtilitiesState>(
  UTILITIES_FEATURE_KEY,
);

export const selectUtilitiesInProgress = createSelector(
  selectUtilitiesState,
  (state: UtilitiesState) => state.count > 0,
);
